module.exports = __webpack_public_path__ + "assets/img/ofa-header.ccd76a84.png";